export default __webpack_public_path__ + "static/media/visual-explorations.7b2552be.jpg";